<template>
  <div>
  <season-totals-menu name="vs-team"></season-totals-menu>
  <div class="segment">
      <div class="columns">
        <div class="column">
          <div class="control">
            <div class="select">
              <select disabled>
                <option>2022 / 2023</option>
              </select>
            </div>
          </div>
          <div class="control">
            <div class="select">
              <select v-model="CompetitionSelected"  @change="fetchSeasonStats">
                <option v-for="option in CompetitionOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
            </div>
          </div>
          <div class="control">
            <div class="select">
              <select  v-model="OpponentSelected"  @change="fetchSeasonStats">
                <option v-for="option in OpponentOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-offset-1">
          <figure class="image is-128x128">
            <img src="https://devils.roblutken.com/devils/assets/player-pictures/Cardiff_Devils.png" alt="" class="is-rounded">
          </figure>
        </div>
        <div class="column">
          <h1 class="title is-uppercase">Cardiff Devils</h1>
          <div class="columns">
            <div class="column">
              <h2 class="subtitle">Team Comparison Tool</h2>
            </div>
          </div>
        </div>
      </div>
  </div>
  <section id="summary">
  <div class="segment box">
    <h1 class="title is-uppercase has-text-centered">Overview</h1>
    <h2 class="subtitle">Cardiff Devils</h2>
    <h3>Forwards</h3>
    <sort-table endpoint="https://devilsapi.roblutken.com/api/app/season-stats/vs-team/"
      :postData="[{
      year: YearSelected,
      competition: 'EIHL',
      venue: VenueSelected,
      team_id: 1,
      opposition: this.OpponentSelected,
      position: 'forwards'
      }]"
      :selectedData="[
          {
            title: 'Player',
            prop: 'player'
          }, 
          {
            title: 'GP',
            prop: 'gp'
          }, 
          {
            title: 'G',
            prop: 'goals'
          }, 
          {
            title: 'PA',
            prop: 'first_assist'
          }, 
          {
            title: 'SA',
            prop: 'second_assist'
          }, 
          {
            title: 'PPTS',
            prop: 'primary_points'
          }, 
          {
            title: 'P',
            prop: 'points',
          }, 
          {
            title: 'PPG',
            prop: 'pp_goals'
          }, 
          {
            title: 'PPP',
            prop: 'pp_points'
          },
          {
            title: 'SOG',
            prop: 'shots_on_net'
          },
          {
            title: 'SH%',
            prop: 'shooting'
          },
          {
            title: 'SHOTS +/-',
            prop: 'shots_diff'
          },
          {
            title: 'TOI / GP',
            prop: 'toi_avg'
          },
          {
            title: 'PIMT',
            prop: 'pim_taken'
          },
          {
            title: 'PIMD',
            prop:'pim_drawn'
          }
      ]" @dataLoaded="gameDataLoaded">
    </sort-table>
    <h3>Defense</h3>
    <sort-table endpoint="https://devilsapi.roblutken.com/api/app/season-stats/vs-team/"
      :postData="[{
      year: YearSelected,
      competition: 'EIHL',
      venue: VenueSelected,
      team_id: 1,
      opposition: this.OpponentSelected,
      position: 'defense'
      }]"
      :selectedData="[
          {
            title: 'Player',
            prop: 'player'
          }, 
          {
            title: 'GP',
            prop: 'gp'
          }, 
          {
            title: 'G',
            prop: 'goals'
          }, 
          {
            title: 'PA',
            prop: 'first_assist'
          }, 
          {
            title: 'SA',
            prop: 'second_assist'
          }, 
          {
            title: 'PPTS',
            prop: 'primary_points'
          }, 
          {
            title: 'P',
            prop: 'points',
          }, 
          {
            title: 'PPG',
            prop: 'pp_goals'
          }, 
          {
            title: 'PPP',
            prop: 'pp_points'
          },
          {
            title: 'SOG',
            prop: 'shots_on_net'
          },
          {
            title: 'SH%',
            prop: 'shooting'
          },
          {
            title: 'SHOTS +/-',
            prop: 'shots_diff'
          },
          {
            title: 'TOI / GP',
            prop: 'toi_avg'
          },
          {
            title: 'PIMT',
            prop: 'pim_taken'
          },
          {
            title: 'PIMD',
            prop:'pim_drawn'
          }
      ]" @dataLoaded="gameDataLoaded">
    </sort-table>
    <h2 class="subtitle">Opponent</h2>
    <h3>Forwards</h3>
    <sort-table endpoint="https://devilsapi.roblutken.com/api/app/season-stats/vs-team/"
      :postData="[{
      year: YearSelected,
      competition: 'EIHL',
      venue: VenueSelected,
      team_id: this.OpponentSelected,
      opposition: 1,
      position: 'forwards'
      }]"
      :selectedData="[
          {
            title: 'Player',
            prop: 'player'
          }, 
          {
            title: 'GP',
            prop: 'gp'
          }, 
          {
            title: 'G',
            prop: 'goals'
          }, 
          {
            title: 'PA',
            prop: 'first_assist'
          }, 
          {
            title: 'SA',
            prop: 'second_assist'
          }, 
          {
            title: 'PPTS',
            prop: 'primary_points'
          }, 
          {
            title: 'P',
            prop: 'points',
          }, 
          {
            title: 'PPG',
            prop: 'pp_goals'
          }, 
          {
            title: 'PPP',
            prop: 'pp_points'
          },
          {
            title: 'SOG',
            prop: 'shots_on_net'
          },
          {
            title: 'SH%',
            prop: 'shooting'
          },
          {
            title: 'SHOTS +/-',
            prop: 'shots_diff'
          },
          {
            title: 'TOI / GP',
            prop: 'toi_avg'
          },
          {
            title: 'PIMT',
            prop: 'pim_taken'
          },
          {
            title: 'PIMD',
            prop:'pim_drawn'
          }
      ]" @dataLoaded="gameDataLoaded">
    </sort-table>
    <h3>Defense</h3>
    <sort-table endpoint="https://devilsapi.roblutken.com/api/app/season-stats/vs-team/"
      :postData="[{
      year: YearSelected,
      competition: 'EIHL',
      venue: VenueSelected,
      team_id: this.OpponentSelected,
      opposition: 1,
      position: 'defense'
      }]"
      :selectedData="[
          {
            title: 'Player',
            prop: 'player'
          }, 
          {
            title: 'GP',
            prop: 'gp'
          }, 
          {
            title: 'G',
            prop: 'goals'
          }, 
          {
            title: 'PA',
            prop: 'first_assist'
          }, 
          {
            title: 'SA',
            prop: 'second_assist'
          }, 
          {
            title: 'PPTS',
            prop: 'primary_points'
          }, 
          {
            title: 'P',
            prop: 'points',
          }, 
          {
            title: 'PPG',
            prop: 'pp_goals'
          }, 
          {
            title: 'PPP',
            prop: 'pp_points'
          },
          {
            title: 'SOG',
            prop: 'shots_on_net'
          },
          {
            title: 'SH%',
            prop: 'shooting'
          },
          {
            title: 'SHOTS +/-',
            prop: 'shots_diff'
          },
          {
            title: 'TOI / GP',
            prop: 'toi_avg'
          },
          {
            title: 'PIMT',
            prop: 'pim_taken'
          },
          {
            title: 'PIMD',
            prop:'pim_drawn'
          }
      ]" @dataLoaded="gameDataLoaded">
    </sort-table>
  </div>
  </section>
  <section id="summary">
  <div class="segment box">
    <h1 class="title is-uppercase has-text-centered">Faceoffs</h1>
    <h1 class="title is-uppercase has-text-centered">Totals</h1>
    <h2 class="subtitle">Cardiff Devils</h2>
    <sort-table endpoint="https://devilsapi.roblutken.com/api/app/season-stats/vs-team/faceoffs"
      :postData="[{
      year: YearSelected,
      competition: 'EIHL',
      venue: VenueSelected,
      team_id: 1,
      opposition: this.OpponentSelected,
      report_breakdown: 'total'
      }]"
      :selectedData="[
          {
            title: 'Player',
            prop: 'player'
          },
          {
            title: 'GP',
            prop: 'gp'
          },
          {
            title: 'Taken',
            prop: 'fo_total_taken'
          },
          {
            title: 'Wins',
            prop: 'fo_total_win_total'
          },
          {
            title: 'Loss',
            prop: 'fo_total_loss_total'
          },
          {
            title: 'Win%',
            prop: 'fo_total_win_percent'
          },
          {
            title: 'Avg Taken',
            prop: 'fo_total_taken_average'
          }
      ]" @dataLoaded="gameDataLoaded">
    </sort-table>
    <h2 class="subtitle">Opponent</h2>
    <sort-table endpoint="https://devilsapi.roblutken.com/api/app/season-stats/vs-team/faceoffs"
      :postData="[{
      year: YearSelected,
      competition: 'EIHL',
      venue: VenueSelected,
      team_id: this.OpponentSelected,
      opposition: 1,
      report_breakdown: 'total'
      }]"
      :selectedData="[
          {
            title: 'Player',
            prop: 'player'
          },
          {
            title: 'GP',
            prop: 'gp'
          },
          {
            title: 'Taken',
            prop: 'fo_total_taken'
          },
          {
            title: 'Win',
            prop: 'fo_total_win_total'
          },
          {
            title: 'Loss',
            prop: 'fo_total_loss_total'
          },
          {
            title: 'Win%',
            prop: 'fo_total_win_percent'
          },
          {
            title: 'Avg Taken',
            prop: 'fo_total_taken_average'
          }
        
      ]" @dataLoaded="gameDataLoaded">
    </sort-table>
    <h1 class="title is-uppercase has-text-centered">Lane</h1>
    <h2 class="subtitle">Cardiff Devils</h2>
    <sort-table endpoint="https://devilsapi.roblutken.com/api/app/season-stats/vs-team/faceoffs"
      :postData="[{
      year: YearSelected,
      competition: 'EIHL',
      venue: VenueSelected,
      team_id: 1,
      opposition: this.OpponentSelected,
      report_breakdown: 'lane'
      }]"
      :selectedData="[
          {
            title: 'Player',
            prop: 'player'
          },
          {
            title: 'GP',
            prop: 'gp'
          },
          {
            title: 'L Taken',
            prop: 'fo_left_taken'
          },
          {
            title: 'L Win',
            prop: 'fo_left_win_total'
          },
          {
            title: 'L Loss',
            prop: 'fo_left_loss_total'
          },
          {
            title: 'L W%',
            prop: 'fo_left_win_percent'
          },
          {
            title: 'C Taken',
            prop: 'fo_center_taken'
          },
          {
            title: 'C Win',
            prop: 'fo_center_win_total'
          },
          {
            title: 'C Loss',
            prop: 'fo_center_loss_total'
          },
          {
            title: 'C W%',
            prop: 'fo_center_win_percent'
          },
          {
            title: 'R Taken',
            prop: 'fo_right_taken'
          },
          {
            title: 'R Win',
            prop: 'fo_right_win_total'
          },
          {
            title: 'R Loss',
            prop: 'fo_right_loss_total'
          },
          {
            title: 'R W%',
            prop: 'fo_right_win_percent'
          }
         
      ]" @dataLoaded="gameDataLoaded">
    </sort-table>
    <h2 class="subtitle">Opponent</h2>
    <sort-table endpoint="https://devilsapi.roblutken.com/api/app/season-stats/vs-team/faceoffs"
      :postData="[{
      year: YearSelected,
      competition: 'EIHL',
      venue: VenueSelected,
      team_id: this.OpponentSelected,
      opposition: 1,
      report_breakdown: 'lane'
      }]"
      :selectedData="[
          {
            title: 'Player',
            prop: 'player'
          },
          {
            title: 'GP',
            prop: 'gp'
          },
          {
            title: 'L Taken',
            prop: 'fo_left_taken'
          },
          {
            title: 'L Win',
            prop: 'fo_left_win_total'
          },
          {
            title: 'L Loss',
            prop: 'fo_left_loss_total'
          },
          {
            title: 'L W%',
            prop: 'fo_left_win_percent'
          },
          {
            title: 'C Taken',
            prop: 'fo_center_taken'
          },
          {
            title: 'C Win',
            prop: 'fo_center_win_total'
          },
          {
            title: 'C Loss',
            prop: 'fo_center_loss_total'
          },
          {
            title: 'C W%',
            prop: 'fo_center_win_percent'
          },
          {
            title: 'R Taken',
            prop: 'fo_right_taken'
          },
          {
            title: 'R Win',
            prop: 'fo_right_win_total'
          },
          {
            title: 'R Loss',
            prop: 'fo_right_loss_total'
          },
          {
            title: 'R W%',
            prop: 'fo_right_win_percent'
          }
        
      ]" @dataLoaded="gameDataLoaded">
    </sort-table>
  </div>
  </section>
  <section id="FOPVP">
    <faceoffs-pvp :opponent="OpponentSelected" :game_id=0></faceoffs-pvp>
  </section>
  <section id="shotmaps">
    <TeamShotMap :home_name="'Cardiff Devils'" :year="YearSelected" :home_id="1" :away_id="OpponentSelected" :competition="CompetitionSelected" :opponent="OpponentSelected" :venue="VenueSelected"></TeamShotMap>
  </section>
  </div>
</template>
<script>
import DataTable from '../data-table'
import SubTable from '../sub-table'
import SeasonTotals from '../season-totals-menu'
import Chart from 'vue-bulma-chartjs'
import TeamShotMap from '../shots-heatmap-team'
import SortTable from '../sort-table'
import FaceoffsPVP from './faceoffs-pvp.vue'
// import _ from 'lodash'
export default {
  components: {
    'data-table': DataTable,
    'sub-table': SubTable,
    'season-totals-menu': SeasonTotals,
    TeamShotMap,
    'sort-table': SortTable,
    Chart,
    'faceoffs-pvp': FaceoffsPVP
  },
  data () {
    return {
      GameFilter: [],
      FilterHeadings: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      LimitOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 8,
      PeriodSelected: 0,
      SituationSelected: 0,
      LimitSelected: 0
    }
  },
  computed: {
  },
  methods: {
    fetchSeasonStats () {
    },
    fetchFilterOptions () {
      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(
          response => {
            // console.log(response.data)
            let venue = response.data.venue
            this.VenueOptions.push({text: 'All', value: 0})
            for (var i = 0; i < venue.length; i++) {
              this.VenueOptions.push({text: venue[i].location, value: venue[i].location})
            }
            let opponent = response.data.teams
            this.OpponentOptions.push({text: 'All', value: 0})
            for (var j = 0; j < opponent.length; j++) {
              if (opponent[j].id !== '1') {
                this.OpponentOptions.push({text: opponent[j].name, value: opponent[j].id})
              }
            }
            let situations = response.data.situations
            this.SituationOptions.push({text: 'All', value: 0})
            this.SituationOptions.push({text: '--Primary Situations--', value: -6})
            this.SituationOptions.push({text: 'Even Handed', value: -1})
            this.SituationOptions.push({text: 'Power Play', value: -2})
            this.SituationOptions.push({text: 'Short Handed', value: -3})
            this.SituationOptions.push({text: 'Empty Net', value: -4})
            this.SituationOptions.push({text: '--Secondary Situations--', value: -5})
            for (var s = 0; s < situations.length; s++) {
              this.SituationOptions.push({text: situations[s].secondary_situation, value: situations[s].id})
            }
            this.CompetitionOptions.push({text: 'All', value: 0})
            this.CompetitionOptions.push({text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup'})
            this.CompetitionOptions.push({text: 'EIHL', value: 'EIHL'})
            this.CompetitionOptions.push({text: 'Challenge Cup', value: 'Challenge-Cup'})
            this.CompetitionOptions.push({text: 'Pre-Season', value: 'Pre-Season'})
            this.CompetitionOptions.push({text: 'Playoffs', value: 'Playoffs'})
            this.CompetitionOptions.push({text: 'CHL', value: 'CHL'})

            this.PeriodOptions.push({text: 'All', value: 0})
            this.PeriodOptions.push({text: 'Period 1', value: 1})
            this.PeriodOptions.push({text: 'Period 2', value: 2})
            this.PeriodOptions.push({text: 'Period 3', value: 3})
            this.PeriodOptions.push({text: 'Period OT', value: 4})
            this.PeriodOptions.push({text: 'Period Shootout', value: 5})

            this.LimitOptions.push({text: 'All', value: 0})
            this.LimitOptions.push({text: '5 Games', value: 5})
            this.LimitOptions.push({text: '10 Games', value: 10})
            this.LimitOptions.push({text: '20 Games', value: 20})
          }
        )
    }
  },
  created () {
    this.fetchFilterOptions()
  }
}
</script>
<style lang='scss' scoped>

.segment {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 98%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.small-box {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 98%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.segment h1 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 3em;
}
.segment h2 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 2em;
}
.segment p{
  font-size:1.2em;
  text-transform: uppercase;
}
.stat-title{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.3rem;
  margin: 1rem 0rem;
}
.stat-category{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.5rem;
  margin: 1rem 0rem;
}
.stat-number{
  font-family: 'Heebo', sans-serif;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.3rem;
  margin: 1rem 0rem;
  color:black;
}
</style>



// WEBPACK FOOTER //
// vs_team.vue?2dd7c6a4